import { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import PurchaseOrderDailyOutboundTxn from 'src/atomic-components/templates/PageBoard/PurchaseOrder/PurchaseOrderDailyOutboundTxn';
import PurchaseOrderDashboard from 'src/atomic-components/templates/PageBoard/PurchaseOrder/PurchaseOrderDashboard';
import PurchaseOrderPreview from 'src/atomic-components/templates/PageBoard/PurchaseOrder/PurchaseOrderPreview';

const PurchaseOrderPage: FC = () => {
  return (
    <Routes>
      <Route path='/preview' element={<PurchaseOrderPreview />} />
      <Route path='/dashboard/:tab' element={<PurchaseOrderDashboard />} />
      <Route path='/daily-outbound-transaction/:tab' element={<PurchaseOrderDailyOutboundTxn />} />
      <Route path='/' element={<Navigate to='./preview' replace />} />
    </Routes>
  );
};

export default PurchaseOrderPage;
